<template>
  <MainContent>
    <b-card>
      <nx-bform @submit="onSubmit">
        <h5>
          {{ $t("forgetCertificationtitle") }}
        </h5>

        <nx-bform-server-errors name="server-errors" />

        <LoginNameFormGroup
          label-cols="2"
          label-align="right"
          v-model="form.username"
          required
        />

        <LoginEmailFormGroup
          label-cols="2"
          label-align="right"
          v-model="form.email"
          required
        />
        <b-form-group label-cols="2">
          <router-link :to="{ name: 'LoginCertificationActivationKeyView' }">
             {{ $t("query.activationKeyForCertification") }}
           
          </router-link>
        </b-form-group>       
        <!-- <b-form-group label-cols="2">
          <router-link :to="{ name: 'LoginForgetLoginName' }">
            {{ $t("query.forgetLoginName") }}
          </router-link>
        </b-form-group>
        <b-form-group label-cols="2">
          <router-link :to="{ name: 'LoginActivationKeyView' }">
            {{ $t("query.activationKey") }}
          </router-link>
        </b-form-group>         -->

        <b-form-group label-cols="2">
          <b-button type="submit" class="bd-button mr-2">{{ $t("reset") }}</b-button>
          <b-button variant="danger" @click="redirectLogin">{{$t('cancel')}}</b-button>
        </b-form-group>
      </nx-bform>
    </b-card>
  </MainContent>
</template>

<script>
import MainContent from "../../../components/main/MainContent";
import { EshApi} from "@/api";
import LoginNameFormGroup from "@/forms/login/LoginNameFormGroup";
import LoginEmailFormGroup from "@/forms/login/LoginEmailFormGroup";

export default {
  components: {
    MainContent,
    LoginNameFormGroup,
    LoginEmailFormGroup,
  },
  data() {
    return {
      form: {
        username: "",
        email: "",
      },
    };
  },
  created(){
    this.$nextTick(() => {
      // 選取所有 <fieldset> 元素
      const fieldsets = document.querySelectorAll('fieldset');
      // 遍歷每個 <fieldset>
      fieldsets.forEach(fieldset => {
        // 查找 <fieldset> 中的 <legend>
        let legend = fieldset.querySelector('legend');
        // 如果 <legend> 不存在，創建並插入
        if (!legend) {
          legend = document.createElement('legend');
          legend.textContent = fieldset.getAttribute('label') || ''; // 使用 <fieldset> 的 label 屬性作為文本
          legend.style.all = 'unset'; // 重置所有內聯樣式
          legend.style.display = 'inline-block'; // 確保 <legend> 是塊級元素
          legend.style.fontWeight = 'bold'; // 添加適當的字重
          legend.style.marginBottom = '0.5rem'; // 添加下邊距以避免緊貼其他內容
          fieldset.insertBefore(legend, fieldset.firstChild);
        } else if (fieldset.firstElementChild !== legend) {
          // 如果 <legend> 存在但不是第一個子元素，將其移動到第一個位置
          fieldset.insertBefore(legend, fieldset.firstChild);
        }
        // 處理空白的 <legend>
        if (!legend.textContent.trim()) {
          legend.style.display = 'none'; // 隱藏空白的 <legend>
        }
      })


      // 選取頁面中所有的 <legend> 元素
      const legends = document.querySelectorAll('legend');
      // 遍歷每個 <legend>
      legends.forEach((legend) => {
        // 如果 <legend> 包含 class "text-right"，則刪除該 class
        if (legend.classList.contains('text-right')) {
          legend.classList.remove('text-right');
        }
      })



      // 查找页面中所有的 <fieldset> 元素
      // const fieldsets = document.querySelectorAll('fieldset');

      // 遍历每个 <fieldset>
      fieldsets.forEach((fieldset) => {
        // 获取 <fieldset> 下的 <legend> 元素
        const legend = fieldset.querySelector('legend');

        // 如果 <legend> 存在，获取其文本内容
        if (legend) {
          const legendText = legend.textContent.trim(); // 去除多余空格

          // 查找 <fieldset> 下的所有 <input> 元素
          const inputs = fieldset.querySelectorAll('input');

          // 遍历每个 <input>，为其添加 aria-label 属性
          inputs.forEach((input) => {
            input.setAttribute('aria-label', legendText);
            input.setAttribute('title', legendText);
          })
        }
      })
    })
  },
  methods: {
    async onSubmit() {
      var data = {UserName:this.form.username, Email:this.form.email};
      await EshApi.forgetCertification(data);

      this.$successToast(
        this.$t("messages.successTitle"),
        this.$t("messages.successMsg")
      );
    },
    redirectLogin() {
      this.$router.push({ name: 'Login' });
    },
  },
};
</script>

<style lang="scss">
::v-deep legend{
  text-align: left !important;
}
</style>

<i18n src="@/locales/actions.locale"></i18n>

<i18n src="@/locales/login.locale"></i18n>

<i18n>
{
  "en": {
    "forgetCertificationtitle": "Add digital certificate to existing account",
    "messages": {
      "successTitle": "Email sent",
      "successMsg": "Please reset the digital certificate according to the email"
    }
  },
  "zh_hk": {
    "forgetCertificationtitle": "於現有帳戶加入數碼證書",
     "messages": {
       "successTitle": "郵件已發送",
       "successMsg": "請根據電子郵件重設數碼證書"
    }
  },
  "zh_cn": {
    "forgetCertificationtitle": "于现有帐户加入数码证书",
     "messages": {
       "successTitle": "郵件已發送",
       "successMsg": "請根據電子郵件重設數碼證書"
     }
  }
}
</i18n>
